import React, { useState, useEffect, useContext } from "react";
import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";

const mapContainerStyle = {
    width: "100%",
    height: "350px",
    borderRadius: "10px",
};

const defaultCenter = { lat: 39.5, lng: -98.35 }; // USA center
const defaultZoom = 4.1;

const PlantMap = ({ plantCoordinates = [], projectCoordinates = [] }) => {

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyBUzGu9ytbWBaOeO2peYl5qhZhmp9gPaQY", // ✅ from env
    });

    const [mapCenter, setMapCenter] = useState(defaultCenter);
    const [zoomLevel, setZoomLevel] = useState(defaultZoom);
    const [hovered, setHovered] = useState(null);
    const [activeMarkers, setActiveMarkers] = useState([]);
    const { setSelectedPlantMarker, setProjectId } = useContext(RegisterIdContext);

    // 🔹 Only one set of markers should be active at a time
    useEffect(() => {
        setMapCenter(defaultCenter);
        setZoomLevel(defaultZoom);
        if (plantCoordinates && plantCoordinates.length > 0) {
            setActiveMarkers(plantCoordinates);
        } else if (projectCoordinates && projectCoordinates.length > 0) {
            setActiveMarkers(projectCoordinates);
        } else {
            setActiveMarkers([]);
        }


    }, [plantCoordinates, projectCoordinates]);

    const infoDetail = (marker) => {
        if (marker?.plantId) {
            setSelectedPlantMarker(marker.plantId);

        } else if (!isNaN(Number(marker?.projectId))) {
            const projectId = Number(marker.projectId);
            setProjectId(projectId)
        }
        // setMapCenter({ lat: marker.lat, lng: marker.lng });
        // setZoomLevel(10);
    }

    if (!isLoaded) return <div>Loading Map...</div>;

    return (
        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={mapCenter}
            zoom={zoomLevel}
            mapTypeId="hybrid"
        >
            {activeMarkers.map((marker, idx) => (
                <OverlayView
                    key={idx}
                    position={{ lat: marker.lat, lng: marker.lng }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div
                        style={{ width: "24px", height: "24px", cursor: "pointer" }}
                        onMouseEnter={() => setHovered(marker)}
                        onMouseLeave={() => setHovered(null)}
                        onClick={() => {
                            infoDetail(marker);
                        }}
                    >
                        <img
                            src={
                                marker.veoliaSite
                                    ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                    : "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                            }
                            alt="Marker"
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                </OverlayView>
            ))}

            {hovered && (
                <OverlayView
                    position={{ lat: hovered.lat, lng: hovered.lng }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div
                        style={{
                            position: "absolute",
                            transform: "translate(-50%, -120%)",
                            background: "white",
                            color: "black",
                            padding: "6px 12px",
                            borderRadius: "8px",
                            fontSize: "13px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            whiteSpace: "nowrap",
                            zIndex: 1000,
                        }}
                    >
                        <div style={{ fontWeight: "bold" }}>
                            {hovered.plantname
                                ? `PlantName: ${hovered.plantname}`
                                : hovered.projectName
                                    ? `ProjectName: ${hovered.projectName}`
                                    : "Unknown"}
                        </div>
                    </div>
                </OverlayView>
            )}
        </GoogleMap>
    );
};

export default PlantMap;
